import { useEffect } from "react";
import { getAuth } from "firebase/auth";
import { messaging, getToken } from "../config/firebase";
import { registerPushToken } from "../api/pushTokenApi";

const PUBLIC_VAPID_KEY =
  " BGjvDfCQSJcbUwgR1W_cEqEqqwvfgoZa0D94ANN7lYFxlGdBuTOMuFmOeEHXqDSyE5WNKLlgYHfmu91WGLtFtWA";

export const useNotifications = () => {
  useEffect(() => {
    const registerFCMToken = async () => {
      try {
        // Check if messaging is supported or if we're in WebView
        const isWebView =
          window.navigator.userAgent.includes("wv") ||
          window.navigator.userAgent.includes("WebView") ||
          window.ReactNativeWebView !== undefined ||
          window.navigator.userAgent.includes("ReactNative") ||
          !window.navigator.serviceWorker;

        if (!messaging || isWebView) {
          console.log(
            "🔧 Skipping FCM token registration - messaging not available or in WebView"
          );
          return;
        }

        // Check if user is authenticated
        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
          return;
        }

        // Request notification permission
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
          return;
        }

        // Get FCM token
        const token = await getToken(messaging, { vapidKey: PUBLIC_VAPID_KEY });

        if (!token) {
          console.warn("⚠️ FCM token not received");
          return;
        }

        // Register token with backend
        try {
          console.log("💾 Registering FCM token (useNotifications)", {
            host:
              typeof window !== "undefined"
                ? window.location.hostname
                : "unknown",
            tokenId: token.substring(0, 20) + "...",
            hasUserId: !!user?.uid,
          });

          await registerPushToken({
            token,
            platform: "web",
            userEmail: user.email,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          });
        } catch (persistErr) {
          console.warn("Could not persist push token:", persistErr);
        }
      } catch (error) {
        console.error("🔥 Error registering FCM token:", error);
      }
    };

    // Register token when component mounts
    registerFCMToken();

    // Also register when user changes
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        registerFCMToken();
      }
    });

    return () => unsubscribe();
  }, []);
};
